<!--
 * @Author: LiuMeiYu
 * @Date: 2023-02-02 09:50:28
 * @LastEditors: LiuMeiYu
 * @LastEditTime: 2023-03-15 16:38:40
 * @FilePath: \nivara\src\views\wallet\components\withdrawView.vue
 * @Description: *
 * *
 * Copyright (c) 2023 by yihua, All Rights Reserved.
-->
<template>
  <div class="withdraw-container">
    <div class="withdraw-content">
      <div class="step-content">
        <div class="step-item active">
          <div class="step-state-icon">
            <el-image
              :src="
                require('../../../assets/images/agreement_register_phone_active.png')
              "
            />
          </div>
          Withdraw
        </div>
        <div class="step-line">— — — — — — —</div>
        <div class="step-item">
          <div class="step-state-icon">
            <el-image
              :src="
                require('../../../assets/images/agreement_register_phone.png')
              "
            />
          </div>
          System Handling
        </div>
        <div class="step-line">— — — — — — —</div>
        <div class="step-item">
          <div class="step-state-icon">
            <el-image
              :src="
                require('../../../assets/images/agreement_register_phone.png')
              "
            />
          </div>
          Bank Handling
        </div>
      </div>
      <div class="withdraw-bank-wrap">
        <div class="withdraw-bank-title">Withdrawal Bank</div>
        <div class="withdraw-bank-choose">
          <el-select
            v-model="userWithdrawBankCardData.bank_id"
            @change="withdrawBankCardChange"
          >
            <el-option
              v-for="item in userBindBankListData"
              :key="item.bank_id"
              :label="item.bank_name + ' (' + item.bank_account + ')'"
              :value="item.bank_id"
              style="height: 50px;display: flex;align-items: center;"
            >
              <div style="display: flex;">
                <el-image
                  :src="
                    require('../../../assets/images/banklogo/' +
                      item.bank_logo +
                      '@2x.png')
                  "
                  style="width: 40px;height: 40px;"
                />
                <div style="margin-left: 10px;">{{ item.bank_name }}</div>
                <div style="margin-left: 10px;">{{ item.bank_account }}</div>
              </div>
            </el-option>
          </el-select>
          <el-button type="text" @click="openAddBindBank">Add</el-button>
        </div>
      </div>
      <div class="withdraw-amount-wrap">
        <div class="withdraw-amount-title">Withdrawal Amount</div>
        <div class="withdraw-amount-box">
          <div class="withdraw-currency">
            {{ $store.state.currency_symbol }}
          </div>
          <el-input
            class="withdraw-amount-input"
            ref="withdrawAmountRef"
            v-model="withdrawAmount"
            type="number"
            @keydown="channelInputLimit"
            clearable
            v-if="country"
          />
          <el-input
            class="withdraw-amount-input"
            ref="withdrawAmountRef"
            v-model="withdrawAmount"
            type="number"
            @keydown="channelInputLimitTwo"
            clearable
            v-else
          />
          <div class="withdraw-all" @click="withdrawAll">ALL</div>
        </div>
        <div class="withdraw-tips">
          available balance {{ $store.state.currency_symbol
          }}{{ withdrawObj.cashable_amount }},Minimum Withdraw Amount
          {{ $store.state.currency_symbol }}{{ withdrawObj.minimum_amount }}
        </div>
        <div class="withdraw-customer">
          Typically, the withdraw will be done within 10 minutes and be
          reflected in your account immediately . <br />
          If it takes more than 48 hours,
          <span style="color: #C70E0E;">please contact us</span>.
        </div>
      </div>
      <el-button class="btn-submit-withdraw" @click="submitWithdraw"
        >Submit</el-button
      >
    </div>
    <Popup
      title="add new bank card"
      ref="addBindbankRef"
      @closePopup="closePopup"
    >
      <template #content>
        <el-form
          class="add-bindban-form"
          :model="addBindbankFormData"
          label-position="top"
          v-loading="getBankNameLoading"
          element-loading-text="Get bank card name please wait..."
        >
          <el-form-item label="Bank Category">
            <el-select v-model="addBindbankFormData.bank_category_id">
              <el-option
                v-for="item in bankCategoryListData"
                :key="item.bank_category_id"
                :label="item.bank_name"
                :value="item.bank_category_id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Bank Account Number">
            <el-input
              v-model="addBindbankFormData.bank_account"
              @blur="getBankName"
            />
          </el-form-item>
          <el-form-item label="Bank Account Name">
            <el-input v-model="addBindbankFormData.user_name" />
          </el-form-item>
          <el-button @click="addBindBank">Submit</el-button>
        </el-form>
      </template>
    </Popup>
    <Popup title="withdraw Password" ref="withdrawPasswordRef">
      <template #content>
        <div class="withdraw-password-content">
          <el-input v-model="withdrawPassword" type="password" show-password />
          <el-button @click="userApplyWithdraw">Withdraw</el-button>
        </div>
      </template>
    </Popup>
  </div>
</template>
<script>
import {
  defineComponent,
  onMounted,
  nextTick,
  reactive,
  ref,
  toRefs,
} from "@vue/runtime-core";
import { ElNotification, ElMessageBox } from "element-plus";
import { useStore } from "vuex";
import {
  getUserBankListApi,
  addUserBindBankApi,
  getBankCategoryListApi,
  getUserWithdrawInfoApi,
  userApplyWithdrawApi,
  getUserInfoApi,
  getBankNameApi,
} from "../../../api/index";
import Popup from "../../../components/popupView.vue";
import bus from "../../../utils/eventBus";

export default defineComponent({
  name: "Wallet",
  components: { Popup },
  props: {
    bankId: {
      type: Number,
      default: () => {
        return 0;
      },
    },
  },
  emits: ["withdrawSuccess", "toSettingWithdrawPassword"],
  setup(props, { emit }) {
    onMounted(() => {
      // 国家是尼日利亚
      if (localStorage.getItem("country_id") === "25") {
        country.value = false;
      }
      getUserWithdrawInfo();
      getUserBankList();
      getUserInfo();
    });
    const store = useStore();
    const walletType = ref(0);
    const addBindbankRef = ref(null);
    const getBankNameLoading = ref(null);
    const country = ref(true);
    const withdrawAmount = ref("");
    const withdrawAmountRef = ref(null);
    const withdrawPassword = ref("");
    const withdrawPasswordRef = ref(null);

    const state = reactive({
      // 用户提现的银行卡
      userWithdrawBankCardData: {
        bank_id: "",
      },
      bankCategoryListData: [],
      // 用户绑定的银行卡列表
      userBindBankListData: [],
      addBindbankFormData: {
        bank_category_id: "",
        bank_account: "",
        user_name: "",
      },
      withdrawObj: {
        minimum_amount: 0,
        availableBalance: 0,
      },
      userInfoData: {},
    });
    // 打开添加绑定银行弹框
    const openAddBindBank = () => {
      getBankCategoryList();
      addBindbankRef.value.open();
    };
    // 添加绑定银行
    const addBindBank = () => {
      addUserBindBank();
    };
    // 打开添加绑定银行弹框
    const closePopup = () => {
      state.addBindbankFormData.bank_category_id = "";
      state.addBindbankFormData.bank_account = "";
      state.addBindbankFormData.user_name = "";
    };
    const withdrawBankCardChange = (bankId) => {
      console.log(bankId);
      state.userWithdrawBankCardData.bank_id = bankId;
      console.log("当前提现银行ID：", state.userWithdrawBankCardData.bank_id);
    };
    // 禁止输入负号 和 文字 .
    const channelInputLimit = (e) => {
      let key = e.key;
      // 不允许输入'e'和'.'
      if (key === "e" || key === "-" || key === ".") {
        e.returnValue = false;
        return false;
      }
      return true;
    };
    const channelInputLimitTwo = (e) => {
      let key = e.key;
      // 不允许输入'e'和'.'
      if (key === "e" || key === "-") {
        e.returnValue = false;
        return false;
      }
      return true;
    };
    const withdrawAll = () => {
      withdrawAmount.value = state.withdrawObj.availableBalance;
    };
    // 提交提现
    const submitWithdraw = () => {
      if (state.userWithdrawBankCardData.bank_id) {
        if (withdrawAmount.value) {
          if (withdrawAmount.value < state.withdrawObj.minimum_amount) {
            ElNotification({
              title: "Tips",
              message:
                "Sorry, the minimum withdrawal amount is " +
                state.withdrawObj.minimum_amount +
                store.state.currency_symbol,
              type: "error",
              duration: 2000,
            });
          } else {
            if (withdrawAmount.value > state.withdrawObj.availableBalance) {
              ElNotification({
                title: "Tips",
                message: "You cannot withdraw more than the available balance",
                type: "error",
                duration: 2000,
              });
            } else {
              if (state.userInfoData.t_password_null) {
                ElMessageBox.confirm(
                  "You haven't set your withdrawal password yet, do you want to set it?",
                  "Warning",
                  {
                    confirmButtonText: "OK",
                    cancelButtonText: "Cancel",
                    cancelButtonClass: "cancel-button-style",
                    type: "warning",
                  }
                )
                  .then(() => {
                    emit("toSettingWithdrawPassword");
                  })
                  .catch(() => {});
              } else {
                withdrawPasswordRef.value.open();
              }
            }
          }
        } else {
          ElNotification({
            title: "Tips",
            message: "Please enter withdraw amount",
            type: "error",
            duration: 2000,
          });
          withdrawAmountRef.value.focus();
        }
      } else {
        ElNotification({
          title: "Tips",
          message: "Please select withdraw bank card",
          type: "error",
          duration: 2000,
        });
      }
    };
    // 添加绑定银行卡
    const addUserBindBank = () => {
      if (state.addBindbankFormData.bank_category_id) {
        if (state.addBindbankFormData.bank_account) {
          if (state.addBindbankFormData.user_name) {
            let data = {
              token: localStorage.getItem("token"),
              bank_category_id: state.addBindbankFormData.bank_category_id,
              bank_account: state.addBindbankFormData.bank_account,
              user_name: state.addBindbankFormData.user_name,
            };
            addUserBindBankApi(data).then((res) => {
              console.log("addUserBindBankApi", res);
              if (res.data.success) {
                if (res.data.data.bank_id) {
                  ElNotification({
                    title: "Tips",
                    message: "Add Bank Card Success",
                    type: "success",
                  });
                  addBindbankRef.value.close();
                  nextTick(() => {
                    state.addBindbankFormData.bank_category_id = "";
                    state.addBindbankFormData.bank_account = "";
                    state.addBindbankFormData.user_name = "";
                    // setUserDefaultBindBank(res.data.data.bank_id);
                    getUserBankList();
                    setTimeout(() => {
                      setUserWithdrawBankCard(res.data.data.bank_id);
                    }, 100);
                  });
                }
              }
            });
          } else {
            ElNotification({
              title: "Tips",
              message: "Please enter Bank Account Name",
              type: "error",
            });
          }
        } else {
          ElNotification({
            title: "Tips",
            message: "Please enter Bank Account Number",
            type: "error",
          });
        }
      } else {
        ElNotification({
          title: "Tips",
          message: "Please select Bank Category",
          type: "error",
        });
      }
    };
    // 根据银行和银行号码获取银行名字
    const getBankName = () => {
      // 有银行类型 和银行卡号
      if (
        state.addBindbankFormData.bank_category_id &&
        state.addBindbankFormData.bank_account
      ) {
        getBankNameLoading.value = true;
        let data = {
          token: localStorage.getItem("token"),
          bank_category_id: state.addBindbankFormData.bank_category_id,
          bank_account: state.addBindbankFormData.bank_account,
        };
        getBankNameApi(data)
          .then((res) => {
            console.log(res);
            if (res.data.success) {
              if (res.data.data.user_name) {
                state.addBindbankFormData.user_name = res.data.data.user_name;
              } else {
                ElNotification({
                  title: "Tips",
                  message:
                    "not find the corresponding information, please enter it manually",
                  type: "error",
                });
              }
            }
            getBankNameLoading.value = false;
          })
          .catch(() => {
            ElNotification({
              title: "Tips",
              message: "get corresponding information err",
              type: "error",
            });
            getBankNameLoading.value = false;
          });
      }
    };
    // 设置提现银行
    const setUserWithdrawBankCard = (bankId) => {
      state.userWithdrawBankCardData.bank_id = bankId;
      console.log("当前提现银行ID：", state.userWithdrawBankCardData.bank_id);
    };

    // 获取用户银行卡列表数据
    const getUserBankList = () => {
      getUserBankListApi({ token: localStorage.getItem("token") }).then(
        (res) => {
          console.log("getUserBankListApi：", res);
          if (res.data.success) {
            if (res.data.data.length > 0) {
              state.userBindBankListData = res.data.data;
              if (props.bankId) {
                console.log("银行卡列表传送过来的银行ID：", props.bankId);
                state.userWithdrawBankCardData.bank_id = props.bankId;
                console.log(
                  "当前提现银行ID：",
                  state.userWithdrawBankCardData.bank_id
                );
              } else {
                res.data.data.forEach((item) => {
                  if (item.is_def === 1) {
                    state.userWithdrawBankCardData.bank_id = item.bank_id;
                    console.log(
                      "当前提现银行ID：",
                      state.userWithdrawBankCardData.bank_id
                    );
                  }
                });
              }
            } else {
              state.userBindBankListData = [];
              state.userWithdrawBankCardData.bank_id = "";
            }
          }
        }
      );
    };
    // 获取银行卡种类列表数据
    const getBankCategoryList = () => {
      getBankCategoryListApi({
        token: localStorage.getItem("token"),
        country_id: localStorage.getItem("country_id"),
      }).then((res) => {
        console.log("getBankCategoryListApi", res);
        if (res.data.success) {
          if (res.data.data.length > 0) {
            state.bankCategoryListData = res.data.data;
          } else {
            state.bankCategoryListData = [];
          }
        }
      });
    };
    // 获取提现信息
    const getUserWithdrawInfo = () => {
      getUserWithdrawInfoApi({ token: localStorage.getItem("token") }).then(
        (res) => {
          console.log("getUserWithdrawInfoApi：", res);
          if (res.data.success && res.data.data) {
            state.withdrawObj = res.data.data;
            state.withdrawObj.availableBalance = res.data.data.cashable_amount;
            state.withdrawObj.minimum_amount = res.data.data.minimum_amount;
          }
        }
      );
    };
    // 用户申请提现
    const userApplyWithdraw = () => {
      let data = {
        token: localStorage.getItem("token"),
        bank_id: state.userWithdrawBankCardData.bank_id,
        amount: withdrawAmount.value,
        password: withdrawPassword.value,
      };
      userApplyWithdrawApi(data).then((res) => {
        console.log("userApplyWithdrawApi", res);
        if (res.data.success) {
          ElNotification({
            title: "Tips",
            message: "Apply Withdraw Success",
            type: "success",
          });
          withdrawPasswordRef.value.close();
          nextTick(() => {
            withdrawAmount.value = "";
            withdrawPassword.value = "";
            getUserWithdrawInfo();
            bus.emit("withdrawSuccess");
            emit("withdrawSuccess");
          });
        } else {
          ElNotification({
            title: "Tips",
            message: res.data.msg,
            type: "error",
          });
        }
      });
    };
    const getUserInfo = () => {
      getUserInfoApi({ token: localStorage.getItem("token") }).then((res) => {
        console.log("getUserInfoApi：", res);
        if (res.data.success) {
          state.userInfoData = res.data.data;
        }
      });
    };
    return {
      walletType,
      addBindbankRef,
      getBankNameLoading,
      country,
      withdrawAmount,
      withdrawAmountRef,
      withdrawPassword,
      withdrawPasswordRef,
      openAddBindBank,
      addBindBank,
      getBankName,
      closePopup,
      withdrawBankCardChange,
      channelInputLimit,
      channelInputLimitTwo,
      withdrawAll,
      submitWithdraw,
      addUserBindBank,
      userApplyWithdraw,
      ...toRefs(state),
    };
  },
});
</script>

<style lang="less" scoped>
.withdraw-container {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #333333;
  .withdraw-content {
    .step-content {
      margin-top: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      .step-line {
        padding: 0 20px;
        color: #8f94a2;
      }
      .step-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #999999;
        .step-state-icon {
          .el-image {
            width: 20px;
            height: 20px;
            margin-bottom: 10px;
          }
          .step-unfinish {
            width: 20px;
            height: 20px;
            margin-bottom: 10px;
            background-color: #f5f7f8;
            border-radius: 50%;
          }
        }
        &.active {
          color: #000000;
        }
      }
    }
    .withdraw-bank-wrap {
      margin-top: 40px;
      padding: 20px;
      border-radius: 12px;
      border: 1px solid #e3e3e3;
      .withdraw-bank-title {
        text-align: left;
        font-size: 18px;
        font-weight: bold;
      }
      .withdraw-bank-choose {
        display: flex;
        align-items: center;
        margin-top: 20px;
        .el-select {
          width: 100%;
          height: 60px;
          :deep(.el-input__inner) {
            height: 60px;
            padding: 20px;
            border: none;
            background-color: #f8f8f8;
            font-size: 16px;
            font-weight: bold;
          }
          :deep(.el-input__icon) {
            height: 100%;
          }
        }
        .el-button {
          margin-left: 10px;
          color: #2d43bf !important;
        }
      }
    }
    .withdraw-amount-wrap {
      margin-top: 20px;
      padding: 20px;
      border-radius: 12px;
      border: 1px solid #e3e3e3;
      .withdraw-amount-title {
        text-align: left;
        font-size: 18px;
        font-weight: bold;
      }
      .withdraw-amount-box {
        margin-top: 10px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #e3e3e3;
        .withdraw-currency {
          font-size: 20px;
          font-weight: bold;
        }

        .withdraw-amount-input {
          flex: 1;
          font-size: 24px;
          :deep(.el-input__inner) {
            border: none;
          }
        }

        .withdraw-all {
          color: #0f4392;
          cursor: pointer;
        }
        :deep(input::-webkit-outer-spin-button),
        :deep(input::-webkit-inner-spin-button) {
          -webkit-appearance: none !important;
        }
        :deep(input[type="number"]) {
          -moz-appearance: textfield !important;
        }
      }
      .withdraw-tips {
        margin-top: 10px;
        text-align: left;
        color: #999999;
      }
      .withdraw-customer {
        margin-top: 10px;
        text-align: left;
        color: #999999;
      }
    }
    .btn-submit-withdraw {
      margin-top: 44px;
      padding: 15px 50px;
      background-color: #03034d;
      border-radius: 12px;
      font-size: 16px;
      color: #ffffff;
    }
  }
  .add-bindban-form {
    padding: 20px;
    .el-select {
      width: 100%;
    }
    :deep(.el-form-item) {
      margin-bottom: 10px;
    }
    :deep(.el-form-item__label) {
      padding: 0;
      font-weight: bold;
      color: #000000;
    }
    :deep(.el-input__inner) {
      border-radius: 12px;
    }
    .el-button {
      margin-top: 20px;
      background-color: #03034d;
      border-radius: 12px;
      color: #ffffff;
    }
  }
  .withdraw-password-content {
    padding: 20px;
    .el-button {
      margin-top: 20px;
      background-color: #03034d;
      border-radius: 12px;
      color: #ffffff;
    }
  }
}
</style>
